export default "__VITE_ASSET__DJPwotzp__"